import React from 'react';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { useForgeCommandPaletteModules } from './service/index.tsx';
import { ForgeLinkCommands } from './ui/link-command/index.tsx';
import { ForgeModalCommands } from './ui/modal-command/index.tsx';

export const ForgeCommandPaletteCommandsUnsafe = () => {
	const { loading, jiraCommand, fullPageModules } = useForgeCommandPaletteModules();

	if (loading) return null;

	if (!jiraCommand) return null;

	const pageCommands = jiraCommand.filter((extension) => 'page' in extension.properties.target);

	const modalCommands = jiraCommand.filter(
		(extension) => 'resource' in extension.properties.target,
	);

	return (
		<>
			{pageCommands && <ForgeLinkCommands commands={pageCommands} pageModules={fullPageModules} />}
			{modalCommands && <ForgeModalCommands commands={modalCommands} />}
		</>
	);
};

export const ForgeCommandPaletteCommands = () => (
	<JSErrorBoundary id="forge-compal" teamName="tomatoes" fallback="unmount">
		<ForgeCommandPaletteCommandsUnsafe />
	</JSErrorBoundary>
);

export const ForgeCommandPaletteCommandsWithFF = componentWithFG(
	'forge-command-palette',
	ForgeCommandPaletteCommands,
	() => null,
);
